import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CircularProgress } from '@mui/material';
import { useSigninTFA } from './api/apiAuthentication';
import PropTypes from 'prop-types';
import { useToast } from '../hooks/usetoast';

const schema = yup.object().shape({
    tfaCode: yup.string()
        .required('TFA code is Required')
        .matches(/\d{6}/, 'Invalid TFA code'),
})

const TFAVerify = ({ email }) => {

    const signinMutation = useSigninTFA();

    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            tfaCode: '',
        }
    });
    const toast = useToast()
    const handleKeyDown = e => e.target.value = e.target.value.match(/\d{6}/)[0]

    const onSubmit = async (data) => {
        setLoading(true)
        const sendObj = {
            email: email,
            token: data.tfaCode
        }
        try {
            const res = await signinMutation.mutateAsync(sendObj);


            if (!res?.data?.status) {
                return toast.error(res?.data?.message)
            }

            window.location.href = "/dashboard"
            sessionStorage.setItem('permission', JSON.stringify(res.data?.admin?.permission))
            sessionStorage.setItem('role', res?.data?.role)
            reset();
            sessionStorage.setItem("apayroucarayxczijiuhxvkdsp", res?.data?.token);

        } catch {
            setLoading(false);
        }
    }

    return (
        <section className='d-flex align-items-center' style={{ minHeight: "70vh" }}>
            <div className="crPgFrm crPgFrmIps">
                <div className="crPgWcl-tx-color mb-3">
                    <h3>Two Factor Authentication.</h3>
                    <p>Enter the TFA code from the Authenticator app</p>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} noValidate>

                    <div className="mb-3">
                        <Controller name='tfaCode' control={control} render={({ field }) => (
                            <input
                                {...field}
                                type="number"
                                autoFocus='on'
                                onInput={handleKeyDown}
                                className="form-control text-center"
                                placeholder='Enter TFA code'
                                autoComplete='off'
                                onKeyDown={(e) => {
                                    if (['-', 'e', 'E', '+'].includes(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        )} />
                        {errors.tfaCode && <p className="errMsg">* {errors.tfaCode.message}</p>}
                    </div>

                    <div className="d-grid crPgbtn pt-2">
                        <button className="btn btn-primary" disabled={false}>
                            {loading ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Verify OTP"}                        </button>
                    </div>
                </form>
            </div>
        </section>
    )

}
TFAVerify.propTypes = {
    email: PropTypes.any.isRequired,
};
export default TFAVerify;